import { render } from "./SignPage.vue?vue&type=template&id=5c22f752&scoped=true"
import script from "./SignPage.vue?vue&type=script&lang=js"
export * from "./SignPage.vue?vue&type=script&lang=js"

import "./SignPage.vue?vue&type=style&index=0&id=5c22f752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c22f752"]])

export default __exports__